import { httpGet, httpPost } from "@/request/http";

const path = "manual";

function appendValue(formData, key, value) {
  if (value === null || value === undefined) return;
  formData.append(key, String(value));
}

function appendInstruction(formData, prefix, instruction, idField) {
  if (!instruction.IsNew) {
    appendValue(formData, `${prefix}.${idField}`, instruction[idField]);
  }
  appendValue(formData, `${prefix}.Step`, instruction.Step);
  appendValue(formData, `${prefix}.Title`, instruction.Title);
  appendValue(formData, `${prefix}.Description`, instruction.Description);

  if (instruction.UpdateImage) {
    formData.append(
      `${prefix}.UpdateImage`,
      instruction.UpdateImage,
      instruction.UpdateImage.name
    );
  }
}

export function createManualFormData(manual) {
  const formData = new FormData();

  if (!manual.IsNew) appendValue(formData, "ManualId", manual.ManualId);
  appendValue(formData, "ManualName", manual.ManualName);
  appendValue(formData, "MainMenu", manual.MainMenu);
  appendValue(formData, "SubMenu", manual.SubMenu);
  appendValue(formData, "Title", manual.Title);
  appendValue(formData, "Version", manual.Version);
  appendValue(formData, "UpdatedBy", manual.UpdatedBy);

  (manual.MainInstructions || []).forEach((mainInstruction, mainIndex) => {
    const mainPrefix = `MainInstructions[${mainIndex}]`;
    appendInstruction(
      formData,
      mainPrefix,
      mainInstruction,
      "MainStepId"
    );

    (mainInstruction.SubInstructions || []).forEach(
      (subInstruction, subIndex) => {
        appendInstruction(
          formData,
          `${mainPrefix}.SubInstructions[${subIndex}]`,
          subInstruction,
          "SubStepId"
        );
      }
    );
  });

  return formData;
}

export default {
  getAll(keyword = "") {
    return httpGet(`${path}/all`, { Keyword: keyword });
  },
  get(id) {
    return httpGet(`${path}/${encodeURIComponent(id)}`);
  },
  getByName(manualName) {
    return httpGet(`${path}/name/${encodeURIComponent(manualName)}`);
  },
  save(manual) {
    return httpPost(path, createManualFormData(manual));
  },
  createFormData: createManualFormData,
};
